import { Typography, Avatar, Col, Row, Button } from "antd";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";
import { Link } from "react-router-dom";
import PersonalCard from "../ProfileCards/PersonalCard";
import MyLogCard from "../ProfileCards/MyLogCard";
import NotificationsCard from "../ProfileCards/NotificationsCard";
import MyFavouritesCard from "../ProfileCards/MyFavouritesCard";

const { Title, Paragraph } = Typography;

const NavMenu = () => {
  const { currentUser, logOut } = useLoginContext();

  if (isCompanyUser(currentUser) || !currentUser) return null;

  return (
    <>
      <Row gutter={[16, 16]} align="middle" justify="center" style={{ width: "100%" }}>
        <Col
          span={24}
          style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}
        >
          <Avatar
            size={100}
            icon={currentUser.first_name[0] + currentUser.last_name[0]}
            style={{ backgroundColor: "var(--primary-color)", marginBottom: "15px" }}
          />
          <Title level={2}>Hei, {currentUser.first_name.replace(/\s+/g, "")}!</Title>
        </Col>

        <Col span={16} style={{ textAlign: "center", paddingBottom: "2em" }}>
          <Paragraph>
            På denne siden kan du blant annet redigere profilen din, se hvilke arrangementer du har deltatt på, og se
            stillingsannonser du har markert som favoritt.
          </Paragraph>
        </Col>
      </Row>

      <Row gutter={[32, 32]} justify="center">
        <Col xs={24} md={12} lg={10}>
          <PersonalCard />
        </Col>
        <Col xs={24} md={12} lg={10}>
          <MyLogCard />
        </Col>
        <Col xs={24} md={12} lg={10}>
          <NotificationsCard />
        </Col>
        <Col xs={24} md={12} lg={10}>
          <MyFavouritesCard />
        </Col>
        <Col span={24} style={{ justifyContent: "center", textAlign: "center" }}>
          <Link
            to="/"
            onClick={() => {
              logOut();
            }}
          >
            <Button type="primary" danger size="large">
              Logg ut
            </Button>
          </Link>
        </Col>
      </Row>
    </>
  );
};

export default NavMenu;
